import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  nextAppointmentLabel: {
    id: 'embeds.components.SecondaryTextDetails.nextAppointmentLabel',
    defaultMessage: 'Next: {date}',
  },
  lastAppointmentLabel: {
    id: 'embeds.components.SecondaryTextDetails.lastAppointmentLabel',
    defaultMessage: 'Last: {date}',
  },
  invalidContact: {
    id: 'embeds.components.SecondaryTextDetails.invalidContact',
    defaultMessage: 'Invalid contact',
  },
});
